/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import DetailHeader from './AssignmentsDetailsHeader';
import SectionTabs from '../../../common/SectionTabs';
import StudentNeedingSupport from './StudentNeedingSupportComponent';
import { useAssignmentsRightContentPanelStyles } from './styles/AssignmentSectionStyles';
import ReviewList from '../../../common/ReviewList';


const AssignmentRightContentPanel = ({
  childTabIndex,
  hanldeChildTabIndexChange,
  dummayUserData,
  selectedAssignment,
  onEditClick,
  onDifficultTopicClick,
  onStudentClick
}) => {
  const classes = useAssignmentsRightContentPanelStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.headerBox}>
        <DetailHeader
          title={selectedAssignment?.title || 'Assignment'}
          estimatedTime="1 hr 30 mins"
          numberOfQuestions={12}
          topics={selectedAssignment?.chapters || []}
          completionPercent={selectedAssignment?.percentComplete || 0}
          onEditClick={onEditClick}
        />
      </Box>
      <SectionTabs
        value={childTabIndex}
        onChange={hanldeChildTabIndexChange}
        tab1Label="Students needing support(5)"
        tab2Label="Difficult topics(3)"
      />

      <Box className={classes.tabContent}>
        {childTabIndex === 0 && (
          <StudentNeedingSupport
            studentData={dummayUserData}
            onStudentClick={onStudentClick}
            assignmentTitle={selectedAssignment?.title || 'Assignment'}
          />
        )}

        {childTabIndex === 1 && (
        <Box className={classes.difficultTopics}>
          <ReviewList
            list={selectedAssignment?.helpTopics}
            onDifficultTopicClick={onDifficultTopicClick}
            assignmentId={selectedAssignment?.id}
          />
        </Box>
        )}
      </Box>
    </Box>
  );
};

AssignmentRightContentPanel.propTypes = {
  childTabIndex: PropTypes.number.isRequired,
  hanldeChildTabIndexChange: PropTypes.func.isRequired,
  dummayUserData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      topics: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired,
  selectedAssignment: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    dueText: PropTypes.string,
    percentComplete: PropTypes.number,
    assignmentComplete: PropTypes.bool,
    chapters: PropTypes.arrayOf(PropTypes.string),
    helpTopics: PropTypes.array
  }),
  onEditClick: PropTypes.func.isRequired,
  onDifficultTopicClick: PropTypes.func.isRequired,
  onStudentClick: PropTypes.func.isRequired
};

export default AssignmentRightContentPanel;
